import { NgModule } from '@angular/core';
import { LockerStoreService } from './locker-store.service';

@NgModule({
  imports: [],
  providers: [LockerStoreService],
  exports: [],
})
export class LockerStoreModule {}
